import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Group,
  Select,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { Controller, useForm } from "react-hook-form";
import { useProperties } from "../../../hooks/useProperties";
import { propertySchema } from "../../../schemas/property.schema";

export default function AddEditPropertyForm() {
  const { useAddEditProperty, onCancel } = useProperties();
  const { loading, submitData, clientSelectData } = useAddEditProperty();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      location: "",
      owner: "",
    },
    resolver: yupResolver(propertySchema),
  });

  return (
    <Box>
      <Box bg={"#F04684"} w={"100%"} px={"md"} py={"xs"}>
        <Text fw={600} size="lg" c={"white"}>
          Add Property
        </Text>
      </Box>
      <Box
        p={"md"}
        style={{ maxHeight: "calc(100vh - 50px)", overflowY: "auto" }}
      >
        <form
          onSubmit={handleSubmit((values) => {
            submitData({
              values,
              onSuccess() {
                reset();
              },
            });
          })}
        >
          <Stack>
            <TextInput
              label="Property name"
              placeholder="Property name"
              {...register("name")}
              error={errors.name?.message}
            />
            <TextInput
              label="Location"
              placeholder="Location"
              {...register("location")}
              error={errors.location?.message}
            />
            <Controller
              name="owner"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Select
                  label="Client owner"
                  placeholder="Select an owner"
                  data={clientSelectData}
                  {...field}
                  value={field.value || null}
                  error={error?.message}
                />
              )}
            />
            <Group justify="space-between">
              <Button
                variant="light"
                disabled={loading}
                onClick={() => {
                  onCancel({
                    action() {
                      reset();
                    },
                  });
                }}
              >
                Cancel
              </Button>
              <Button type="submit" loading={loading}>
                Create
              </Button>
            </Group>
          </Stack>
        </form>
      </Box>
    </Box>
  );
}
